import { render, staticRenderFns } from "./NextButton.vue?vue&type=template&id=3ebfe65f&scoped=true&"
import script from "./NextButton.vue?vue&type=script&lang=ts&"
export * from "./NextButton.vue?vue&type=script&lang=ts&"
import style0 from "./NextButton.vue?vue&type=style&index=0&id=3ebfe65f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebfe65f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/2/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VTooltip})
